import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { MatFormFieldAppearance, MatFormField, MatLabel } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
    selector: 'app-select-type-objet-maquette',
    templateUrl: './select-type-objet-maquette.component.html',
    styleUrls: ['./select-type-objet-maquette.component.scss'],
    imports: [MatFormField, NgStyle, MatLabel, MatSelect, ReactiveFormsModule, MatOption]
})
export class SelectTypeObjetMaquetteComponent {
    TypeObjetMaquette = TypeObjetMaquette;
    readonly control = input.required<FormControl<TypeObjetMaquette | null>>();
    readonly appearance = input<MatFormFieldAppearance>();
    readonly formFieldStyles = input<object>();
}
